<script setup lang="ts">
import { computed } from 'vue';
import { useOrderEditStore } from '@/stores/orderEdit';
import { fillText, useEditTexts } from '@/composables/useEditTexts';
import EditContact from './edit-contact.vue';

// « Recevoir mon lien de modification » (spec §4.4, §9.2): e-mails the
// personal edit link to the booking's address. A booking without an address
// can't receive one: the contact line instead.
const store = useOrderEditStore();
const t = useEditTexts();

const canSend = computed(() => !!store.view?.maskedEmail);
const errorText = computed(() =>
  store.linkError === 'too_many_requests' ? t.edit_menu_link_too_many : t.edit_menu_link_failed,
);
</script>

<template>
  <div class="edit-link-request">
    <p v-if="store.linkState === 'sent' && store.linkSentTo" role="status" data-testid="edit-link-sent">
      {{ fillText(t.edit_menu_link_sent, { email: store.linkSentTo }) }}
    </p>
    <template v-else-if="canSend">
      <button
        type="button"
        data-testid="edit-link-button"
        :disabled="store.linkState === 'sending'"
        :class="{ 'is-disabled': store.linkState === 'sending' }"
        class="el-button bpa-front-btn bpa-front-btn__medium bpa-front-btn--primary el-button--default"
        @click="store.requestLink()"
      >
        <span><strong>{{ t.edit_menu_link_button }}</strong></span>
      </button>
      <p v-if="store.linkState === 'error'" role="alert" class="edit-link-request__error" data-testid="edit-link-error">
        {{ errorText }}
      </p>
    </template>
    <edit-contact v-else />
  </div>
</template>

<style scoped>
.edit-link-request {
  margin: 8px 0 16px;
}

.edit-link-request__error {
  color: #b00020;
}
</style>
